import store from '../store/store';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import { observer } from 'mobx-react';

const styles = require('./UpNext.scss');
const classNames = require('classnames');

@observer
export default class UpNext extends React.Component<{}> {
    render() {
        const nextMeetingInfo = store.nextMeetingInformation;

        let name: string;
        let location: string;
        let time: string;
        let isMeetingIn5MinRange: boolean;

        if (!nextMeetingInfo) {
            name = strings.noEvents;
        } else {
            name = nextMeetingInfo.name;
            location = nextMeetingInfo.location;
            time = nextMeetingInfo.timeUntilMeeting;
        }

        return (
            <>
                <div className={styles.container}>
                    <div className={styles.left}>
                        <span className={styles.next}>{strings.next}</span>
                        <span className={styles.name} title={name}>
                            {name}
                        </span>
                        <span className={styles.location} title={location}>
                            {location}
                        </span>
                    </div>
                    <div className={styles.right}>
                        <span
                            className={classNames(
                                isMeetingIn5MinRange && styles.important,
                                styles.time
                            )}>
                            {time}
                        </span>
                    </div>
                </div>
            </>
        );
    }
}
